<!--余额中心-->
<template>
  <div class="com-table balance border">
    <div class="com-title pr">余额中心</div>
    <search :data="search.list" @click="updateConditions"></search>
    <el-table
      :data="table.list"
      style="width: 100%"><template slot="empty">
      <no-data></no-data>
    </template>
      <el-table-column
        prop="title"
        label="项目名称">
      </el-table-column>
      <el-table-column
        prop="industry"
        label="所属行业">
      </el-table-column>
      <el-table-column
        prop="saler"
        label="销售经理">
      </el-table-column>
      <el-table-column
        prop="increment"
        label="客服经理">
      </el-table-column>
      <el-table-column
        prop="money"
        label="现金余额">
      </el-table-column>
      <el-table-column prop="beforeYesterdayCostCoin" label="前日消费" align="right" header-align="center"
      >
        <template slot-scope="scope">
          <!-- <div class="count">{{scope.row.beforeYesterdayCostCoin}} 点</div> -->
          <div>{{scope.row.beforeYesterdayCostMoney}} 元</div>
        </template>
      </el-table-column>
      <el-table-column prop="yesterdayCostCoin" label="昨日消费" align="right" header-align="center"
      >
        <template slot-scope="scope">
          <!-- <div class="count">{{scope.row.yesterdayCostCoin}} 点</div> -->
          <div>{{scope.row.yesterdayCostMoney}} 元</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="canConsumeDay" label="可消费天数" align="right" header-align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.canConsumeDay <= 0" style="color: red">已欠费</span>
          <span v-else>
              <span v-if="scope.row.canConsumeDay <= 7" style="color: orange">可消费 {{scope.row.canConsumeDay.toFixed(2)}} 天</span>
              <span v-else style="color: green">可消费 {{scope.row.canConsumeDay.toFixed(2)}} 天</span>
            </span>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, sizes, prev, pager, next, jumper"
      :current-page.sync="table.pagination.page"
      :total="table.pagination.totalRow"
      :page-size="table.pagination.pageSize"
      :page-sizes="table.pagination.pageSizes"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>
<script>
  import Api from '@/api/statistics'
  import Search from '@/components/common/Search.vue'
  import { SEARCH_CONDITION } from '@/models/client/balance-center'
  import ResponseParse from '@/utils/response-parse'

  export default {
    created () {
      this.search.list = SEARCH_CONDITION
      this.requestList()
      this.customerItems()
    },
    components: {
      Search
    },
    data () {
      return {
        search: {
          list: [],
          condition: {}
        },
        table: {
          loading: true,
          list: [],
          pagination: {}
        }
      }
    },
    methods: {
      requestList () {
        let search = Object.assign({}, this.pagination, this.search.condition)
        Api.theBalanceTo({search: search}, response => {
          let status = response.data.code
          let body = response.data.data
          if (status === '200') {
            this.table.list = body
            this.table.pagination = ResponseParse.pagination(response.headers)
          } else {
            this.table.list = []
          }
        })
      },
      customerItems () {
        const search = Object.assign({}, this.search.condition)
        Api.customerItem({search: search}, response => {
          let status = response.data.code
          let data = response.data
          if (status === '200') {
            this.titleName = data.data
            this.search.list[0].config.list = []
            let project = []
            this.titleName.forEach(item => {
              if (item.status === 1) {
                project.unshift({value: item.id, label: item.title})
              } else {
                project.push({value: item.id, label: item.title, disabled: true})
              }
            })
            this.search.list[0].config.list = project
          }
          this.table.loading = false
        })
      },
      handleDelete (index, rows) {
        rows.splice(index, 1)
      },
      handleSizeChange (val) {
        this.table.pagination.pageSize = val
        this.requestList()
      },
      handleCurrentChange (val) {
        this.table.pagination.page = val
        this.requestList()
      },
      updateConditions (conditions) {
        this.table.pagination.page = 1
        const date = conditions.date || []
        this.search.condition = Object.assign({}, conditions, {startTime: date[0], endTime: date[1]})
        this.requestList()
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '../../assets/styles/env';

  .message {
    background: $color-white;
    padding: 21px 48px 100px 30px;
    color: $color-gray;
    font-size: $font-secondary;
    &-top {
      .el-input {
        width: 380px;
      }
    }
    &-tabs {

    }
  }
</style>
<style lang="scss">
  .message {
    &-tabs {
      .el-tabs__header {
        margin: 0;
      }
    }
    .el-table th {
      background: white;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/client/BalanceCenter.vue